import React from 'react';

const PdfEditorContext = React.createContext();

export default PdfEditorContext;